import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import FinancialProductRulesEditDetailsServicesTableRow from './FinancialProductRulesEditDetailsServicesTableRow';
import { sequence, get } from '@totalsoft/change-tracking-react';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
import { StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsServicesTableBody = ({
  canWrite,
  serviceList,
  financialProductRuleServiceTypeList,
  financialProductRuleServiceDetailCalcTypeList,
  financialProductRuleSupplierList,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleServiceValidation,
  onLoadFinancialProductRuleSupplierList
}) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(financialProductRuleServiceValidation) &&
        !sequence(serviceList)?.find((_, index) => {
          return !isValid(financialProductRuleServiceValidation[index]);
        }) && (
          <StyledTableRow>
            <Typography color='error'>{t('FinancialProduct.Details.Rules.Details.Services.ValidationList')}</Typography>
          </StyledTableRow>
        )}
      {sequence(serviceList)?.map((service, index) => {
        return (
          <FinancialProductRulesEditDetailsServicesTableRow
            canWrite={canWrite}
            financialProductRuleServiceTypeList={financialProductRuleServiceTypeList}
            financialProductRuleServiceDetailCalcTypeList={financialProductRuleServiceDetailCalcTypeList}
            financialProductRuleSupplierList={financialProductRuleSupplierList}
            key={`${index}_${service.financialProductRuleXServiceTypeId |> get}`}
            serviceLens={service}
            index={index}
            onCloseEdit={onCloseEdit}
            onDelete={onDelete}
            onSave={onSave}
            validation={financialProductRuleServiceValidation[index]}
            onLoadFinancialProductRuleSupplierList={onLoadFinancialProductRuleSupplierList}
            listValid={isValid(financialProductRuleServiceValidation)}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductRulesEditDetailsServicesTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  serviceList: PropTypes.object.isRequired,
  financialProductRuleServiceTypeList: PropTypes.array.isRequired,
  financialProductRuleServiceDetailCalcTypeList: PropTypes.array.isRequired,
  financialProductRuleSupplierList: PropTypes.array.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleServiceValidation: PropTypes.object.isRequired,
  onLoadFinancialProductRuleSupplierList: PropTypes.func.isRequired
};

export default FinancialProductRulesEditDetailsServicesTableBody;
